/** Default logged-in landing for the resume product funnel. */
export const DASHBOARD_HOME_PATH = "/dashboard/resume";

/** Query flag to keep the Resume → Jobs → Boost guide visible. */
export const SETUP_QUERY = "setup=1";

export function resumeSetupPath() {
  return `${DASHBOARD_HOME_PATH}?${SETUP_QUERY}`;
}

export function jobsSetupPath() {
  return `/dashboard/jobs?${SETUP_QUERY}`;
}
